import React from 'react';
import { HashRouter as Router, Routes, Route, Link, useParams } from 'react-router-dom';
import BlogList from './pages/BlogList.tsx';
import GlobalStyle from './styles/GlobalStyle.ts';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { posts } from './data/Posts.tsx';

const PostRouter = () => {
    const { id } = useParams();

    const post = posts.find(p => p.id === id);

    if (!post) {
        return <div style={{ padding: "20px" }}>Post not found</div>;
    }

    const Component = post.component;
    return <Component />;
};

const App: React.FC = () => (
    <>
        <GlobalStyle />

        <Router>
            <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
                <div className="container-fluid">

                    <Link className="navbar-brand" to="/">
                        Fırat Özkan
                    </Link>

                    <button
                        className="navbar-toggler"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarNav"
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>

                    <div className="collapse navbar-collapse" id="navbarNav">
                        <ul className="navbar-nav">

                            <li className="nav-item">
                                <Link className="nav-link" to="/">
                                    Home
                                </Link>
                            </li>

                            <li className="nav-item dropdown">
                                <span
                                    className="nav-link dropdown-toggle"
                                    role="button"
                                    data-bs-toggle="dropdown"
                                >
                                    Posts
                                </span>

                                <ul className="dropdown-menu bg-dark">
                                    {posts.map((post) => (
                                        <li key={post.id}>
                                            <Link
                                                className="dropdown-item bg-dark text-white"
                                                to={`/posts/${post.id}`}
                                            >
                                                {post.title}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </li>

                        </ul>
                    </div>
                </div>
            </nav>

            <div className="banner">
                <Routes>
                    <Route path="/" element={<BlogList />} />
                    <Route path="/posts/:id" element={<PostRouter />} />
                </Routes>
                <br />
            </div>
        </Router>
    </>
);

export default App;